/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../shared/components/Localized';

export default function Status({ status }) {
  switch (status) {
    case 'ongoing': {
      return <Localized modelName={'modal'} modelKey={'status'} modelAttribute={'valueOngoing'} />;
    }
    case 'resolved': {
      return <Localized modelName={'modal'} modelKey={'status'} modelAttribute={'valueResolved'} />;
    }
    default: {
      return <Localized modelName={'fieldOption'} modelKey={status} modelAttribute={'value'} />;
    }
  }
}
